// @flow

import * as React from 'react';
import ReactDOM from 'react-dom';

type PageHiddenPropsType = {
  children: React.Node,
};

class PageHidden extends React.Component<PageHiddenPropsType> {
  hiddenElement: HTMLElement | null;

  wrapperElement: HTMLDivElement;

  constructor(props: PageHiddenPropsType) {
    super(props);

    this.hiddenElement = document.querySelector('#ace-hidden');
    this.wrapperElement = document.createElement('div');

    if (!this.hiddenElement) {
      this.hiddenElement = document.createElement('div');
      this.hiddenElement.id = 'ace-hidden';

      if (document.body) {
        // TODO: Replace appendChild with append when IE11 is no longer not supported
        document.body.appendChild(this.hiddenElement);
      }
    }

    // TODO: Replace appendChild with append when IE11 is no longer not supported
    this.hiddenElement.appendChild(this.wrapperElement);
  }

  componentWillUnmount() {
    if (this.hiddenElement) {
      this.hiddenElement.removeChild(this.wrapperElement);
    }
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.wrapperElement);
  }
}

export { PageHidden };
